webpackJsonp([1],{

/***/ "+FwJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppLanguages_vue__ = __webpack_require__("xxkG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76856738_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppLanguages_vue__ = __webpack_require__("jPKv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("8Xhr")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppLanguages_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76856738_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppLanguages_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76856738_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppLanguages_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1lFH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);

var state = {
  languages: ['en', 'us', 'es', 'de', 'ja', 'zh', 'fr', 'it', 'pl', 'tr', 'pt', 'br', 'th', 'vn', 'cz', 'ko', 'ro'],
  available: [],
  snips: [],
  missing: []
};

var getters = {};

var mutations = {
  SetAvailableLanguages: function SetAvailableLanguages(state, payload) {
    state.available = payload;
  },
  SetLanguageSnips: function SetLanguageSnips(state, payload) {
    state.snips = payload;
  },
  SetMissingSnips: function SetMissingSnips(state, payload) {
    state.missing = payload;
  },
  SaveNewSnip: function SaveNewSnip(state, payload) {
    state.snips.unshift(payload);
    state.missing.splice(0, 1);
  }
};

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
  state: state,
  getters: getters,
  mutations: mutations
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "2XUo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_languages__ = __webpack_require__("fsWc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_basic_Btn__ = __webpack_require__("RUB1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_basic_Dialog__ = __webpack_require__("nCf0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_basic_Field__ = __webpack_require__("W6kK");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EnterLanguagePassword',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_languages__["a" /* default */]],
  data: function data() {
    return {
      password: '',
      isError: false
    };
  },
  mounted: function mounted() {
    this.$refs['languages-password'].$el.focus();
  },

  methods: {
    ok: function ok() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var isOK;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.languagesVerifyPassword(_this.password);

              case 2:
                isOK = _context.sent;

                if (isOK) {
                  _this.$emit('ok');
                } else {
                  console.log('Error logging in');
                  _this.$nextTick(function () {
                    _this.isError = true;
                  });
                  setTimeout(function () {
                    _this.isError = false;
                  }, 500);
                  _this.$refs['languages-password'].$el.focus();
                }

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  components: {
    IzDialog: __WEBPACK_IMPORTED_MODULE_4__components_basic_Dialog__["a" /* default */],
    Field: __WEBPACK_IMPORTED_MODULE_5__components_basic_Field__["a" /* default */],
    Btn: __WEBPACK_IMPORTED_MODULE_3__components_basic_Btn__["a" /* default */]
  }
});

/***/ }),

/***/ "3Uzn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_Languages_Home__ = __webpack_require__("sk1G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_Languages_One__ = __webpack_require__("gBNx");


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);




/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'LanguagesHome',
    component: __WEBPACK_IMPORTED_MODULE_2__modules_Languages_Home__["a" /* default */]
  }, {
    path: '/:lang',
    name: 'LanguagesOne',
    component: __WEBPACK_IMPORTED_MODULE_3__modules_Languages_One__["a" /* default */]
  }]
}));

/***/ }),

/***/ "4cq1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_basic_Btn__ = __webpack_require__("RUB1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_basic_Field__ = __webpack_require__("W6kK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_languages__ = __webpack_require__("fsWc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_basic_SearchBox__ = __webpack_require__("TlvB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_basic_ProgressBar__ = __webpack_require__("omHR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_file_saver__ = __webpack_require__("t4zo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_file_saver__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Home',
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_languages__["a" /* default */]],
  components: {
    Field: __WEBPACK_IMPORTED_MODULE_6__components_basic_Field__["a" /* default */],
    Btn: __WEBPACK_IMPORTED_MODULE_5__components_basic_Btn__["a" /* default */],
    SearchBox: __WEBPACK_IMPORTED_MODULE_8__components_basic_SearchBox__["a" /* default */],
    ProgressBar: __WEBPACK_IMPORTED_MODULE_9__components_basic_ProgressBar__["a" /* default */]
  },
  data: function data() {
    return {
      searchString: '',
      isLoaded: false,
      dirtySnips: []
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])({
    snips: function snips(state) {
      return state.snips;
    },
    missing: function missing(state) {
      return state.missing;
    }
  }), {
    lang: function lang() {
      return this.$route.params.lang;
    },
    filteredSnips: function filteredSnips() {
      var _this = this;

      if (!this.snips || !this.snips.length) {
        return [];
      }
      return this.snips.filter(function (item) {
        if (!_this.searchString) {
          return true;
        }
        return item._id.toLowerCase().indexOf(_this.searchString.toLowerCase()) > -1 || item[_this.lang].toLowerCase().indexOf(_this.searchString.toLowerCase()) > -1;
      });
    },
    remainingPercent: function remainingPercent() {
      return 100 - Math.round(this.missing.length / (this.snips.length + this.missing.length) * 100);
    }
  }),
  beforeMount: function beforeMount() {
    window.addEventListener('beforeunload', this.preventNavWithoutSave);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('beforeunload', this.preventNavWithoutSave);
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.dirtySnips.length) {
      if (!window.confirm('Leave without saving?')) {
        return;
      }
    }
    next();
  },
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this2.$store.commit('SetLanguageSnips', []);
              _this2.$store.commit('SetMissingSnips', []);
              _context.next = 4;
              return _this2.languagesGetMissing(_this2.lang);

            case 4:
              _context.next = 6;
              return _this2.languagesGetOne(_this2.lang);

            case 6:
              _this2.isLoaded = true;
              _this2.$refs.showAll.checked = _this2.missing.length === 0;
              _this2.focusMissing();

            case 9:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  },

  methods: {
    preventNavWithoutSave: function preventNavWithoutSave(event) {
      if (!this.dirtySnips.length) return;
      event.preventDefault();
      // Chrome requires returnValue to be set.
      event.returnValue = '';
    },
    handleSearch: function handleSearch(val) {
      this.searchString = val;
      // make sure list is visible when starting search
      if (val) {
        this.$refs.showAll.checked = true;
      }
    },
    saveCurrent: function saveCurrent() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this3.missing[0][_this3.lang]) {
                  _context2.next = 4;
                  break;
                }

                _context2.next = 3;
                return _this3.languagesSaveSnip(_this3.lang, _this3.missing[0]);

              case 3:
                _this3.$store.commit('SaveNewSnip', _this3.missing[0]);

              case 4:
                _this3.focusMissing();

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    handleChange: function handleChange(el, val) {
      if (this.dirtySnips.indexOf(el) === -1) {
        this.dirtySnips.push(el);
      }
      // console.log('this.dirtySnips', this.dirtySnips)
    },
    focusMissing: function focusMissing() {
      var _this4 = this;

      if (this.missing.length) {
        setTimeout(function () {
          _this4.$refs.singleSnip.$el.focus();
        }, 100);
      }
    },
    supplyDefault: function supplyDefault() {
      this.$set(this.missing[0], this.lang, this.missing[0]._id);
    },
    saveDirty: function saveDirty() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this5.languagesSaveMultipleSnips(_this5.lang, _this5.dirtySnips);

              case 2:
                _this5.dirtySnips = [];

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    download: function download() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var toSave, file, fileClone;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                // await this.languagesDownloadSnip(this.lang)
                toSave = {};

                _this6.snips.forEach(function (item) {
                  toSave[item._id] = item[_this6.lang];
                });
                // console.log('Saving', JSON.parse(JSON.stringify(toSave)))
                file = new File(['{' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(toSave) + '}'], _this6.lang + '.json', { type: 'application/json' });
                // need to do manual cutting of [] characters forced by the blob

                fileClone = file.slice(1, file.size - 1);
                // console.log(fileClone, saveAs)

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_file_saver__["saveAs"])(fileClone, _this6.lang + '.json');

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    }
  }
});

/***/ }),

/***/ "7bXw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button",class:_vm.classObject,on:{"click":_vm.internalButtonClick}},[_c('em',[_vm._v(" ")]),_vm._v(" "),(_vm.icon)?_c('svg',[_c('use',{attrs:{"xlink:href":'#' + _vm.icon}})]):_vm._e(),_vm._v(" "),(_vm.text)?_c('span',{staticClass:"flex align-center"},[_vm._v(_vm._s(_vm.text))]):_vm._e(),_vm._v(" "),(_vm.toggle)?_c('label',{staticClass:"button-toggler"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isToggled),expression:"isToggled"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.isToggled)?_vm._i(_vm.isToggled,null)>-1:(_vm.isToggled)},on:{"change":function($event){var $$a=_vm.isToggled,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isToggled=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isToggled=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isToggled=$$c}}}})]):_vm._e(),_vm._v(" "),(_vm.fills)?_c('div',{staticClass:"fill-progress",class:{complete: _vm.fillStarted}}):_vm._e(),_vm._v(" "),(_vm.rightIcon)?_c('svg',{staticClass:"right-icon"},[_c('use',{attrs:{"xlink:href":'#' + _vm.rightIcon}})]):_vm._e(),_vm._v(" "),(_vm.rightText)?_c('div',{staticClass:"flex items-center ml-auto"},[_vm._v("\n      "+_vm._s(_vm.rightText)+"\n    ")]):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []


/***/ }),

/***/ "8FVN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DropOverlay_vue__ = __webpack_require__("sA9B");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ff123c7_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DropOverlay_vue__ = __webpack_require__("LnXg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("iigN")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0ff123c7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DropOverlay_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ff123c7_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DropOverlay_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ff123c7_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DropOverlay_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8Xhr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BCKL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-1 flex relative"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchString),expression:"searchString"}],ref:"searchElement",staticClass:"search-box",class:{'something': (_vm.searchString !== ''), disabled: _vm.disabled},attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":(_vm.searchString)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchString=$event.target.value}}}),_vm._v(" "),(_vm.searchString)?_c('svg',{staticClass:"cancel-search",on:{"click":_vm.reset}},[_c('use',{attrs:{"xlink:href":'#cancel-red'}})]):_vm._e()])}
var staticRenderFns = []


/***/ }),

/***/ "Bkr8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{ref:"label",class:_vm.classObject,attrs:{"data-id":_vm.randomId,"data-type":_vm.type}},[(_vm.icon)?_c('svg',{staticClass:"field-icon",class:{'icon-right': _vm.iconRight}},[_c('use',{attrs:{"xlink:href":'#' + _vm.icon}})]):_vm._e(),_vm._v(" "),(_vm.isRegularInput)?_c('input',{ref:"mainInput",class:{centeredText: _vm.centeredText},attrs:{"id":_vm.id,"type":_vm.inputType,"readonly":_vm.isReadOnly,"disabled":_vm.disabled},domProps:{"value":_vm.visibleValue},on:{"input":_vm.setNewValue,"keyup":[_vm.toggleAccesibilityDropdown,function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.$emit('enter')}],"blur":function($event){_vm.$emit('blur')}}}):_vm._e(),_vm._v(" "),(_vm.inputType === 'number')?_c('input',{ref:"numInput",class:{centeredText: _vm.centeredText, isFocused: _vm.isFocused},attrs:{"id":_vm.id,"type":"number","min":_vm.min,"max":_vm.max,"readonly":_vm.isReadOnly,"title":"","disabled":_vm.disabled},domProps:{"value":_vm.visibleValue},on:{"input":_vm.setNewValue,"keyup":_vm.toggleAccesibilityDropdown,"focus":function($event){
var i = arguments.length, argsArray = Array(i);
while ( i-- ) argsArray[i] = arguments[i];
_vm.receivedFocus.apply(void 0, argsArray.concat( [true] ))},"blur":function($event){
var i = arguments.length, argsArray = Array(i);
while ( i-- ) argsArray[i] = arguments[i];
_vm.receivedFocus.apply(void 0, argsArray.concat( [false] ))}}}):_vm._e(),_vm._v(" "),(_vm.inputType === 'checkbox')?_c('input',{attrs:{"id":_vm.id,"type":"checkbox","readonly":_vm.isReadOnly,"disabled":_vm.disabled},domProps:{"value":_vm.value,"checked":_vm.value},on:{"click":_vm.setNewValue}}):_vm._e(),_vm._v(" "),(_vm.pmValue && !_vm.disabled)?_c('div',{staticClass:"plus-minus"},[_c('btn',{attrs:{"icon":"minus","small":"","invert":""},nativeOn:{"click":function($event){_vm.doPM(-1)}}}),_vm._v(" "),_c('btn',{attrs:{"icon":"plus","small":"","invert":""},nativeOn:{"click":function($event){_vm.doPM(1)}}})],1):_vm._e(),_vm._v(" "),(_vm.isDropDown)?_c('input',{ref:"checkbox",staticClass:"close-by-overlay",attrs:{"type":"checkbox","id":_vm.id,"disabled":_vm.disabled},on:{"change":_vm.dropEvent}}):_vm._e(),_vm._v(" "),(_vm.isDropDown)?_c('div',{staticClass:"revealed-dropdown",class:{above: _vm.opensAbove, search: _vm.hasSearch},on:{"click":function($event){_vm.dropClick()}}},[(_vm.isDropDown && _vm.hasSearch)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],ref:"search",staticClass:"search-box gray thin",attrs:{"type":"text"},domProps:{"value":(_vm.searchText)},on:{"keyup":_vm.trySelectFromSearch,"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"options-scroll",style:(_vm.styleDropdown)},[_vm._l((_vm.optionsPossiblyFiltered),function(item,index){return _c('span',{key:index,attrs:{"data-value":item.value || item}},[_c('a',{class:{'selected': (( _vm.value ? _vm.value.value || _vm.value : _vm.value ) === (item.value || item)) || ((item.value || item) === (_vm.selectedFromDropdown.value || _vm.selectedFromDropdown))},on:{"click":function($event){_vm.setResultOption(item)}}},[_vm._v(_vm._s(item.label || item))])])}),_vm._v(" "),(!_vm.optionsPossiblyFiltered.length)?_c('span',{staticClass:"empty-list"},[_c('svg',{staticClass:"w-4 h-4"},[_c('use',{attrs:{"xlink:href":'#cancel'}})])]):_vm._e()],2)]):_vm._e(),_vm._v(" "),(_vm.type === 'path')?_c('btn',{attrs:{"disabled":_vm.disabled,"icon":"open","small":""},nativeOn:{"click":function($event){_vm.openBrowseDialog()}}}):_vm._e(),_vm._v(" "),(_vm.type === 'path')?_c('btn',{attrs:{"disabled":_vm.disabled || !_vm.value,"icon":"cancel","small":""},nativeOn:{"click":function($event){_vm.clearCurrentPath()}}}):_vm._e(),_vm._v(" "),(_vm.hasSpinner)?_c('div',{staticClass:"spinner"}):_vm._e(),_vm._v(" "),(_vm.keyboard)?_c('NumericKeyboard',{staticClass:"osk",on:{"digit":_vm.receiveKeyboardInput}}):_vm._e(),_vm._v(" "),(!_vm.noLabel)?_c('i',{class:{'error': _vm.error, 'auto-label': _vm.autoLabel,'label-3': _vm.label3,'label-10': _vm.label10, 'label-20': _vm.label20, 'label-15': _vm.label15}},[_vm._v(_vm._s(_vm.label))]):_vm._e()],1)}
var staticRenderFns = []


/***/ }),

/***/ "DCo6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DXG0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"numeric-keyboard flex"},[_c('Btn',{attrs:{"text":"1","center":""},nativeOn:{"click":function($event){
var i = arguments.length, argsArray = Array(i);
while ( i-- ) argsArray[i] = arguments[i];
$event.stopPropagation();_vm.setValue.apply(void 0, argsArray.concat( [1] ))}}}),_vm._v(" "),_c('Btn',{attrs:{"text":"2","center":""},nativeOn:{"click":function($event){
var i = arguments.length, argsArray = Array(i);
while ( i-- ) argsArray[i] = arguments[i];
$event.stopPropagation();_vm.setValue.apply(void 0, argsArray.concat( [2] ))}}}),_vm._v(" "),_c('Btn',{attrs:{"text":"3","center":""},nativeOn:{"click":function($event){
var i = arguments.length, argsArray = Array(i);
while ( i-- ) argsArray[i] = arguments[i];
_vm.setValue.apply(void 0, argsArray.concat( [3] ))}}}),_vm._v(" "),_c('Btn',{attrs:{"text":"4","center":""},nativeOn:{"click":function($event){
var i = arguments.length, argsArray = Array(i);
while ( i-- ) argsArray[i] = arguments[i];
_vm.setValue.apply(void 0, argsArray.concat( [4] ))}}}),_vm._v(" "),_c('Btn',{attrs:{"text":"5","center":""},nativeOn:{"click":function($event){
var i = arguments.length, argsArray = Array(i);
while ( i-- ) argsArray[i] = arguments[i];
_vm.setValue.apply(void 0, argsArray.concat( [5] ))}}}),_vm._v(" "),_c('Btn',{attrs:{"text":"6","center":""},nativeOn:{"click":function($event){
var i = arguments.length, argsArray = Array(i);
while ( i-- ) argsArray[i] = arguments[i];
_vm.setValue.apply(void 0, argsArray.concat( [6] ))}}}),_vm._v(" "),_c('Btn',{attrs:{"text":"7","center":""},nativeOn:{"click":function($event){
var i = arguments.length, argsArray = Array(i);
while ( i-- ) argsArray[i] = arguments[i];
_vm.setValue.apply(void 0, argsArray.concat( [7] ))}}}),_vm._v(" "),_c('Btn',{attrs:{"text":"8","center":""},nativeOn:{"click":function($event){
var i = arguments.length, argsArray = Array(i);
while ( i-- ) argsArray[i] = arguments[i];
_vm.setValue.apply(void 0, argsArray.concat( [8] ))}}}),_vm._v(" "),_c('Btn',{attrs:{"text":"9","center":""},nativeOn:{"click":function($event){
var i = arguments.length, argsArray = Array(i);
while ( i-- ) argsArray[i] = arguments[i];
_vm.setValue.apply(void 0, argsArray.concat( [9] ))}}}),_vm._v(" "),_c('Btn',{attrs:{"icon":"back","center":""},nativeOn:{"click":function($event){
var i = arguments.length, argsArray = Array(i);
while ( i-- ) argsArray[i] = arguments[i];
_vm.setValue.apply(void 0, argsArray.concat( [-1] ))}}}),_vm._v(" "),_c('Btn',{attrs:{"text":"0","center":""},nativeOn:{"click":function($event){
var i = arguments.length, argsArray = Array(i);
while ( i-- ) argsArray[i] = arguments[i];
_vm.setValue.apply(void 0, argsArray.concat( [0] ))}}}),_vm._v(" "),_c('Btn',{attrs:{"icon":"ok","center":""},nativeOn:{"click":function($event){
var i = arguments.length, argsArray = Array(i);
while ( i-- ) argsArray[i] = arguments[i];
_vm.setValue.apply(void 0, argsArray.concat( [-2] ))}}})],1)}
var staticRenderFns = []


/***/ }),

/***/ "EnGP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GPOn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_languages__ = __webpack_require__("fsWc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_basic_Btn__ = __webpack_require__("RUB1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_basic_Field__ = __webpack_require__("W6kK");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Home',
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_languages__["a" /* default */]],
  components: {
    Btn: __WEBPACK_IMPORTED_MODULE_5__components_basic_Btn__["a" /* default */],
    Field: __WEBPACK_IMPORTED_MODULE_6__components_basic_Field__["a" /* default */]
  },
  data: function data() {
    return {
      newSnip: ''
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])({
    languages: function languages(state) {
      return state.languages;
    },
    available: function available(state) {
      return state.available;
    }
  }), {
    isAdmin: function isAdmin() {
      // empty language means admin
      return this.available.indexOf('') > -1;
    }
  }),
  methods: {
    isLanguageAvailable: function isLanguageAvailable(code) {
      return this.available.indexOf(code) > -1;
    },
    logout: function logout() {
      console.log('Logging out');
      localStorage.removeItem('token');
      location.reload();
    },
    saveNew: function saveNew() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.languagesSaveSnip('en', { _id: _this.newSnip, en: _this.newSnip });

              case 2:
                _this.newSnip = '';

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});

/***/ }),

/***/ "H68n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iz-dialog',{staticClass:"modal-languages-password",attrs:{"title":"Login","disableOverlay":""}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('field',{ref:"languages-password",staticClass:"flex-1",class:{invalid: _vm.isError},attrs:{"label":"Password","input-type":"password","label10":""},on:{"enter":function($event){_vm.ok()}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('btn',{attrs:{"icon":"back","error":""},nativeOn:{"click":function($event){_vm.$emit('cancel')}}}),_vm._v(" "),_c('btn',{attrs:{"icon":"ok","success":""},nativeOn:{"click":function($event){_vm.ok($event)}}})],1)])}
var staticRenderFns = []


/***/ }),

/***/ "KduR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal"},[_c('header',[(_vm.title)?_c('h2',[_vm._v(_vm._s(_vm.title)+"\n    "),(_vm.simboltitle && (_vm.simboltitle === 'upper'))?_c('svg',{staticClass:"side "},[_c('use',{attrs:{"xlink:href":'#side-front'}})]):_vm._e(),_vm._v(" "),(_vm.simboltitle && (_vm.simboltitle === 'lower'))?_c('svg',{staticClass:"side "},[_c('use',{attrs:{"xlink:href":'#side-back'}})]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.$slots.header)?_c('h2',[_vm._t("header")],2):_vm._e()]),_vm._v(" "),_c('section',{staticClass:"body relative",class:{scroll: this.scroll}},[_vm._t("body",[_vm._v("Default body")])],2),_vm._v(" "),_c('footer',{staticClass:"relative"},[_vm._t("footer",[_c('btn',{attrs:{"icon":"ok","success":""},nativeOn:{"click":function($event){_vm.closeDialog()}}})])],2),_vm._v(" "),(!_vm.disableOverlay)?_c('DropOverlay'):_vm._e()],1)}
var staticRenderFns = []


/***/ }),

/***/ "LPj7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Lm2a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LnXg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlay",class:{'visible': _vm.visible},on:{"click":function($event){_vm.triggerMassClose()}}})}
var staticRenderFns = []


/***/ }),

/***/ "MbGm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MsIs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-1 flex flex-col items-center justify-center"},[_c('h1',{staticClass:"mb-05"},[_vm._v("InkZone translation tool")]),_vm._v(" "),_c('section',{staticClass:"flex flex-wrap space-around"},_vm._l((_vm.languages),function(code){
var _obj;
return _c('router-link',{key:code,staticClass:"flag label",class:( _obj = {}, _obj[code] = true, _obj.available = _vm.isLanguageAvailable(code), _obj ),attrs:{"to":("/" + code)}})})),_vm._v(" "),(_vm.isAdmin)?_c('section',{staticClass:"flex mt-05 w-full"},[_c('Field',{staticClass:"flex-1",attrs:{"label":"Add new","label10":""},model:{value:(_vm.newSnip),callback:function ($$v) {_vm.newSnip=$$v},expression:"newSnip"}}),_vm._v(" "),_c('Btn',{attrs:{"small":"","icon":"plus"},nativeOn:{"click":function($event){_vm.saveNew($event)}}})],1):_vm._e(),_vm._v(" "),(this.available.length)?_c('a',{staticClass:"tcyan inline-flex mt-1 cursor-pointer mb-1",on:{"click":_vm.logout}},[_vm._v("Logout")]):_vm._e()])}
var staticRenderFns = []


/***/ }),

/***/ "PJJj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EnterLanguagePassword_vue__ = __webpack_require__("2XUo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f7810c1_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EnterLanguagePassword_vue__ = __webpack_require__("H68n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("f21r")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2f7810c1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EnterLanguagePassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f7810c1_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EnterLanguagePassword_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f7810c1_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EnterLanguagePassword_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RUB1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Btn_vue__ = __webpack_require__("h2MN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eac823b_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Btn_vue__ = __webpack_require__("7bXw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("xMpl")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0eac823b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Btn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eac823b_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Btn_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eac823b_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Btn_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Tbz3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TlvB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchBox_vue__ = __webpack_require__("yKGw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50a359dd_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchBox_vue__ = __webpack_require__("BCKL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("LPj7")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-50a359dd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchBox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50a359dd_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchBox_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50a359dd_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchBox_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Usg1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");

var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

/***/ }),

/***/ "W6kK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Field_vue__ = __webpack_require__("l+4t");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00c9b7dc_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Field_vue__ = __webpack_require__("Bkr8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("EnGP")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-00c9b7dc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Field_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00c9b7dc_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Field_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00c9b7dc_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Field_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cklV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_basic_Btn__ = __webpack_require__("RUB1");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import SimpleKeyboard from '@/components/Basic/KeyboardBasic'
// import Btn from '@/components/Basic/Btn'


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NumericKeyboard',
  components: {
    Btn: __WEBPACK_IMPORTED_MODULE_0__components_basic_Btn__["a" /* default */]
    // SimpleKeyboard
  },
  data: function data() {
    return {
      input: ''
    };
  },
  methods: {
    setValue: function setValue(ev, value) {
      ev.stopPropagation();
      ev.preventDefault();
      console.log('click event', ev);
      this.$emit('digit', value);
    }
  }
});

/***/ }),

/***/ "f21r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fsWc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    languagesGetToken: function languagesGetToken() {
      var token = localStorage.getItem('token');
      return token || null;
    },
    languagesVerifyPassword: function languagesVerifyPassword(pass) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/api/languages/login', {}, {
                  headers: { 'X-Login-Token': pass }
                });

              case 3:
                _ref = _context.sent;
                data = _ref.data;

                // if we're here it means it worked
                localStorage.setItem('token', pass);
                _this.$store.commit('SetAvailableLanguages', data);
                return _context.abrupt('return', true);

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](0);

                localStorage.removeItem('token');
                return _context.abrupt('return', false);

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 10]]);
      }))();
    },
    languagesGetOne: function languagesGetOne(code) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref2, snipDocs;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/languages/get/' + code, {
                  headers: { 'X-Login-Token': _this2.languagesGetToken() }
                });

              case 3:
                _ref2 = _context2.sent;
                snipDocs = _ref2.data;

                _this2.$store.commit('SetLanguageSnips', snipDocs);
                // console.log('Docs', snipDocs)
                _context2.next = 12;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](0);

                console.log('Error getting one', _context2.t0.message);
                return _context2.abrupt('return', false);

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 8]]);
      }))();
    },
    languagesGetMissing: function languagesGetMissing(code) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _ref3, snipDocs;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/languages/missing/' + code, {
                  headers: { 'X-Login-Token': _this3.languagesGetToken() }
                });

              case 3:
                _ref3 = _context3.sent;
                snipDocs = _ref3.data;

                _this3.$store.commit('SetMissingSnips', snipDocs);
                // console.log('Docs', snipDocs)
                _context3.next = 12;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3['catch'](0);

                console.log('Error getting one', _context3.t0.message);
                return _context3.abrupt('return', false);

              case 12:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 8]]);
      }))();
    },
    languagesSaveSnip: function languagesSaveSnip(lang, doc) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var _ref4, snipDocs;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                console.log('Saving snip doc', doc);
                _context4.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/api/languages/save_snip/' + lang, doc, {
                  headers: { 'X-Login-Token': _this4.languagesGetToken() }
                });

              case 4:
                _ref4 = _context4.sent;
                snipDocs = _ref4.data;

                console.log('Docs', snipDocs);
                _context4.next = 13;
                break;

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4['catch'](0);

                console.log('Error saving snip', _context4.t0.message);
                return _context4.abrupt('return', false);

              case 13:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 9]]);
      }))();
    },
    languagesSaveMultipleSnips: function languagesSaveMultipleSnips(lang, listOf) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var snipsToSave, _ref5, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;

                // extract snips from store
                snipsToSave = _this5.$store.state.snips.filter(function (item) {
                  return listOf.indexOf(item._id) > -1;
                });
                _context5.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/api/languages/save_multiple/' + lang, snipsToSave, {
                  headers: { 'X-Login-Token': _this5.languagesGetToken() }
                });

              case 4:
                _ref5 = _context5.sent;
                data = _ref5.data;

                console.log('Saving multiple', snipsToSave, data);
                _context5.next = 13;
                break;

              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5['catch'](0);

                console.log('Error saving multiple snips', _context5.t0.message);
                return _context5.abrupt('return', false);

              case 13:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[0, 9]]);
      }))();
    }
  }
});

/***/ }),

/***/ "gBNx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_One_vue__ = __webpack_require__("4cq1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0e0cd52_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_One_vue__ = __webpack_require__("jzhq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("Tbz3")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d0e0cd52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_One_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0e0cd52_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_One_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0e0cd52_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_One_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gDHX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KeyboardNumeric_vue__ = __webpack_require__("cklV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe5f76c4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KeyboardNumeric_vue__ = __webpack_require__("DXG0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("DCo6")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KeyboardNumeric_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe5f76c4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KeyboardNumeric_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe5f76c4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KeyboardNumeric_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gjZ5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__event_bus_js__ = __webpack_require__("Usg1");




/* global delphi, winformObj */

/*
*  Connection API to Delphi host
*  Alternative connection to CSharp host to keep unified api system
* */


/* harmony default export */ __webpack_exports__["a"] = ({
  getDongleData: function getDongleData() {
    try {
      // call straight function on C# host
      // getDongleData must be defined in host
      var result = winformObj.getDongleData();
      // console.log('getDongleData', result)
      // JSON.parse(result) - obiectul
      // for perfect (and other dongle-requiring apps)
      __WEBPACK_IMPORTED_MODULE_4__event_bus_js__["a" /* EventBus */].$emit('SetStatusbarInfoDongle', JSON.parse(result));
    } catch (e) {}
  },
  getAllUsers: function getAllUsers() {
    try {
      // call straight function on C# host
      var result = winformObj.getAllUsers();
      // console.log('getAllUsers', result)
      // JSON.parse(result) - obiectul
      __WEBPACK_IMPORTED_MODULE_4__event_bus_js__["a" /* EventBus */].$emit('SetUsers', JSON.parse(result));
    } catch (e) {}
  },
  callback: function callback(functionName) {
    var args = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from___default()(arguments);
    args.shift();
    var parsedArguments = args.map(function (item) {
      // console.log('type of argument', typeof item)
      if ((typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(item)) === 'object') {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(item);
      }
      return item;
    });

    /* Delphi variant */
    if (typeof delphi !== 'undefined') {
      if (parsedArguments.length) {
        var _delphi;

        (_delphi = delphi).callback.apply(_delphi, [functionName].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(parsedArguments)));
      } else {
        delphi.callback(functionName);
      }
    }

    /* CSharp variant */
    // console.log('Calling host function', functionName, parsedArguments)
    // console.log('Passed args', ...parsedArguments)
    if (typeof winformObj !== 'undefined') {
      var _winformObj;

      // function name should start lowercase
      var formattedFunctionName = functionName.charAt(0).toLowerCase() + functionName.slice(1);
      return (_winformObj = winformObj)[formattedFunctionName].apply(_winformObj, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(parsedArguments));

      // if (parsedArguments.length) {
      //   // console.log('Calling server with arguments', parsedArguments)
      //   // console.log('Calling server with ...arguments', ...parsedArguments)
      //   winformObj.invokeFunction(functionName, parsedArguments)
      // } else {
      //   winformObj.invokeFunction(functionName, [])
      // }
    }

    /* Webview2 variant */
    if (window.chrome && window.chrome.webview) {
      // console.log('Sending webview callback')
      var passedObject = { _function: functionName, _args: parsedArguments };
      window.chrome.webview.postMessage(passedObject);
    }
  }
});

/***/ }),

/***/ "h2MN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Btn',
  props: {
    /* used for toggle buttons */
    value: {
      type: Boolean,
      default: false
    },
    text: [String, Number],
    icon: String,
    medium: Boolean,
    big: Boolean,
    tight: Boolean,
    small: {
      type: Boolean,
      default: false
    },
    toggle: {
      type: Boolean,
      default: false
    },
    error: Boolean,
    success: Boolean,
    warning: Boolean,
    pending: Boolean, // new state needed by cockpit
    noTransform: Boolean,
    invert: Boolean,
    blueText: Boolean,
    textOnly: Boolean,
    redIcon: Boolean,
    centerIcon: Boolean,
    center: {
      type: Boolean,
      default: false
    },
    square: {
      /* removes the padding and makes it a square button */
      type: Boolean,
      default: false
    },
    round: {
      /* used on the settings pages inside lists */
      type: Boolean,
      default: false
    },
    to: {
      /* provides link to another page */
      type: [String, Object]
    },
    rightIcon: {
      /* used for green checkmark mostly */
      type: String
    },
    addToList: {
      /* used in a list of vertical buttons, to add new items */
      type: Boolean
    },
    fills: {
      /* used on the scan button to show progress on the button directly */
      type: Boolean,
      default: false
    },
    fillStarted: {
      /* signals the fill operation to start */
      type: Boolean,
      default: false
    },
    forceWrap: Boolean,
    largeBorder: Boolean,
    mediumBorder: Boolean,
    invertHover: Boolean,
    rightText: {
      type: String,
      default: ''
    },
    ellipsis: Boolean
  },
  data: function data() {
    return {
      isToggled: false
    };
  },

  computed: {
    classObject: function classObject() {
      return {
        big: this.big,
        medium: this.medium,
        tight: this.tight,
        blueText: this.blueText,
        redIcon: this.redIcon,
        small: this.small,
        error: this.error,
        success: this.success,
        warning: this.warning,
        pending: this.pending,
        noTransform: this.noTransform,
        invert: this.invert,
        square: this.square,
        center: this.center,
        centerIcon: this.centerIcon,
        toggled: this.isToggled,
        round: this.round,
        textOnly: this.textOnly,
        addToList: this.addToList,
        forceWrap: this.forceWrap,
        largeBorder: this.largeBorder,
        mediumBorder: this.mediumBorder,
        invertHover: this.invertHover,
        ellipsis: this.ellipsis
      };
    }
  },
  methods: {
    internalButtonClick: function internalButtonClick() {
      if (this.to) {
        this.$router.push(this.to);
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler(val) {
        this.isToggled = val;
      }
    },
    isToggled: function isToggled(val) {
      this.$emit('input', val);
    }
  }
});

/***/ }),

/***/ "i8tC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProgressBar',
  props: {
    progress: {
      type: [Number, String],
      default: 0
    },
    isError: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentProgress: function currentProgress() {
      return Math.min(this.progress, 100) + '%';
    }
  }
});

/***/ }),

/***/ "iigN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jPKv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{key:_vm.$route.path}),_vm._v(" "),_c('DropOverlay'),_vm._v(" "),(_vm.showPasswordPrompt)?_c('DialogEnterLanguagePassword',{on:{"ok":_vm.successfulLogin}}):_vm._e()],1)}
var staticRenderFns = []


/***/ }),

/***/ "jzhq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-1 flex flex-col items-center"},[_c('div',{staticClass:"top-bar w-full flex items-center"},[_c('router-link',{staticClass:"go-home",attrs:{"to":"/"}},[_c('svg',{staticClass:"w-1 h-1 ml-05"},[_c('use',{attrs:{"xlink:href":'#previous'}})])]),_vm._v(" "),_c('div',{staticClass:"flag available",class:( _obj = {}, _obj[_vm.lang] = true, _obj )}),_vm._v(" "),_c('Btn',{staticClass:"ml-auto mr-1",attrs:{"blueText":"","text":"Download json"},nativeOn:{"click":function($event){_vm.download($event)}}}),_vm._v(" "),(_vm.dirtySnips.length)?_c('Btn',{staticClass:"mr-1",attrs:{"medium":"","success":"","text":("Save (" + (_vm.dirtySnips.length) + ")"),"icon":"ok"},nativeOn:{"click":function($event){_vm.saveDirty($event)}}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"main-area flex-1 w-full pad-h"},[(!_vm.isLoaded)?_c('div',{staticClass:"flex justify-center pad-v"},[_c('div',{staticClass:"spinner"})]):_vm._e(),_vm._v(" "),(_vm.missing.length && _vm.isLoaded)?_c('div',{staticClass:"mt-1"},[_c('h2',[_vm._v("Left to translate: "+_vm._s(_vm.missing.length))]),_vm._v(" "),_c('ProgressBar',{staticStyle:{"height":"1rem","margin-bottom":"3rem"},attrs:{"progress":_vm.remainingPercent}}),_vm._v(" "),_c('label',[_c('div',{on:{"dblclick":_vm.supplyDefault}},[_vm._v(_vm._s(_vm.missing[0]._id))]),_vm._v(" "),_c('Field',{ref:"singleSnip",on:{"enter":_vm.saveCurrent},model:{value:(_vm.missing[0][_vm.lang]),callback:function ($$v) {_vm.$set(_vm.missing[0], _vm.lang, $$v)},expression:"missing[0][lang]"}})],1),_vm._v(" "),((_vm.lang !== 'en') && _vm.missing[0].en)?_c('small',[_vm._v("EN: "+_vm._s(_vm.missing[0]['en']))]):_vm._e(),_vm._v(" "),((_vm.lang !== 'de') && _vm.missing[0].de)?_c('small',[_vm._v("DE: "+_vm._s(_vm.missing[0]['de']))]):_vm._e(),_vm._v(" "),((_vm.lang !== 'fr') && _vm.missing[0].fr)?_c('small',[_vm._v("FR: "+_vm._s(_vm.missing[0]['fr']))]):_vm._e(),_vm._v(" "),((_vm.lang !== 'es') && _vm.missing[0].es)?_c('small',[_vm._v("ES: "+_vm._s(_vm.missing[0]['es']))]):_vm._e(),_vm._v(" "),_c('Btn',{staticClass:"mt-025",attrs:{"text":"Save translation","blue-text":"","invert":""},nativeOn:{"click":function($event){_vm.saveCurrent($event)}}})],1):_vm._e(),_vm._v(" "),_c('input',{ref:"showAll",attrs:{"type":"checkbox","id":"show-translated"}}),_vm._v(" "),(_vm.snips.length)?_c('label',{staticClass:"toggle-translated block tcyan cursor-pointer flex items-center",attrs:{"for":"show-translated"}},[_c('svg',{staticClass:"w-05 h-05"},[_c('use',{attrs:{"xlink:href":'#previous'}})]),_vm._v("\n      See already translated texts\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"snips-done"},[(_vm.snips.length)?_c('SearchBox',{staticClass:"pad-v-half",attrs:{"input-value":_vm.searchString,"placeholder":"Search..."},on:{"input":_vm.handleSearch}}):_vm._e(),_vm._v(" "),_vm._l((_vm.filteredSnips),function(snip){return _c('div',{key:snip._id,staticClass:"label-and-value"},[_c('label',[_c('div',[_vm._v(_vm._s(snip._id))]),_vm._v(" "),_c('Field',{on:{"input":function($event){
var i = arguments.length, argsArray = Array(i);
while ( i-- ) argsArray[i] = arguments[i];
_vm.handleChange.apply(void 0, [ snip._id ].concat( argsArray ))}},model:{value:(snip[_vm.lang]),callback:function ($$v) {_vm.$set(snip, _vm.lang, $$v)},expression:"snip[lang]"}})],1),_vm._v(" "),((_vm.lang !== 'en') && snip.en)?_c('small',[_vm._v("EN: "+_vm._s(snip['en']))]):_vm._e(),_vm._v(" "),((_vm.lang !== 'de') && snip.de)?_c('small',[_vm._v("DE: "+_vm._s(snip['de']))]):_vm._e(),_vm._v(" "),((_vm.lang !== 'fr') && snip.fr)?_c('small',[_vm._v("FR: "+_vm._s(snip['fr']))]):_vm._e(),_vm._v(" "),((_vm.lang !== 'es') && snip.es)?_c('small',[_vm._v("ES: "+_vm._s(snip['es']))]):_vm._e()])})],2)])])}
var staticRenderFns = []


/***/ }),

/***/ "kLER":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "l+4t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__("RRo+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__delphi_server__ = __webpack_require__("gjZ5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__event_bus_js__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_basic_Btn__ = __webpack_require__("RUB1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_basic_KeyboardNumeric__ = __webpack_require__("gDHX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__KeyboardNumeric__ = __webpack_require__("gDHX");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    NumericKeyboard: __WEBPACK_IMPORTED_MODULE_6__KeyboardNumeric__["a" /* default */],
    Btn: __WEBPACK_IMPORTED_MODULE_4__components_basic_Btn__["a" /* default */],
    KeyboardNumeric: __WEBPACK_IMPORTED_MODULE_5__components_basic_KeyboardNumeric__["a" /* default */]
  },
  props: {
    id: String,
    label: [String, Number],
    type: {
      type: String,
      default: 'text',
      validator: function validator(value) {
        if (!value) {
          return true;
        }
        // checkbox comes in as input-type
        return ['', 'text', 'number', 'dropdown', 'path'].indexOf(value) !== -1;
      }
    },
    triggersConfigSave: Boolean,
    options: Array,
    hasSearch: Boolean,
    error: Boolean,
    value: [String, Number, Object, Boolean],
    maxItems: [String, Number],
    readonly: Boolean,
    alignright: Boolean,
    disabled: Boolean,
    autoLabel: Boolean, // make the label width automatic
    label3: Boolean,
    label10: Boolean,
    label15: Boolean,
    label20: Boolean,
    opensAbove: {
      type: Boolean,
      default: false
    },
    noLabel: {
      type: Boolean,
      default: false
    },
    translatedLabel: Boolean,
    /* if set, it will show plus/minus buttons */
    pmValue: {
      type: Number,
      default: 0
    },
    /* turn on rounding for +- buttons for integers */
    pmRound: {
      type: Boolean,
      default: false
    },
    inputType: {
      type: String,
      default: 'text'
    },
    /* type = number fields */
    min: Number,
    max: Number,
    webUnitsNumber: {
      /* special case for showing web units, units / 2 */
      type: Boolean,
      default: false
    },
    decimals: {
      type: Number,
      default: 1
    },
    // mask for path-type fields
    // transforms the dialog from folder to file select
    fileMask: String,
    // for dropdowns where selection is not fixed
    forceAllowText: Boolean,
    icon: String,
    iconRight: Boolean,
    centeredText: Boolean,
    singleCheckbox: Boolean,
    hasSpinner: Boolean,
    keyboard: Boolean,
    selectAllOnEnter: Boolean
  },
  data: function data() {
    return {
      randomId: 'field-' + this._uid,
      searchText: '',
      isOpen: false,
      selectedFromDropdown: '',
      selectedIndex: null,
      saveTimer: null,
      saveTimeout: 1500,
      isFocused: false,
      justClickedButton: false,
      firstKeyboardClick: false
    };
  },
  mounted: function mounted() {
    /* this should be refactored more nicely */
    if (this.isDropDown && !this.disabled) {
      var activeItem = this.$el.querySelector('span[data-value="' + this.value + '"]');
      activeItem && activeItem.scrollIntoView();
    }

    /* if field is type path, listed for updates from host */
    if (this.type === 'path') {
      this.listenForInputChanges();
    }

    __WEBPACK_IMPORTED_MODULE_3__event_bus_js__["a" /* EventBus */].$on('needsfocus-' + this.randomId, this.fieldNeedsFocus);
  },
  destroyed: function destroyed() {
    if (this.saveTimer) {
      clearTimeout(this.saveTimer);
    }
    /* not necessarily on, but seems to ignore that it's not set */
    __WEBPACK_IMPORTED_MODULE_3__event_bus_js__["a" /* EventBus */].$off('pathchanged-' + this.randomId, this.pathValueUpdated);
    __WEBPACK_IMPORTED_MODULE_3__event_bus_js__["a" /* EventBus */].$off('needsfocus-' + this.randomId, this.fieldNeedsFocus);
  },

  methods: {
    clearCurrentPath: function clearCurrentPath() {
      this.pathValueUpdated('');
      this.$emit('clear');
    },
    checkIfConfigNeedsSaving: function checkIfConfigNeedsSaving() {
      // console.log('triggering save')
      if (!this.triggersConfigSave) {
        return false;
      }
      // console.log('Clearing timer', this.saveTimer)
      if (this.saveTimer) {
        clearTimeout(this.saveTimer);
      }
      this.saveTimer = setTimeout(this.triggerConfigSave, this.saveTimeout);
    },
    triggerConfigSave: function triggerConfigSave() {
      if (this.saveTimer) {
        clearTimeout(this.saveTimer);
      }
      __WEBPACK_IMPORTED_MODULE_3__event_bus_js__["a" /* EventBus */].$emit('save-config-from-field', {});
    },
    trySelectFromSearch: function trySelectFromSearch(ev) {
      if (ev.keyCode === 38) {
        // up
        if (this.selectedIndex === null) {
          this.selectedIndex = 0;
        } else {
          this.selectedIndex--;
        }
        if (this.selectedIndex < 0) {
          this.selectedIndex = this.optionsPossiblyFiltered.length - 1;
        }
        this.selectedFromDropdown = this.optionsPossiblyFiltered[this.selectedIndex];
        this.bringInViewport(this.selectedFromDropdown);
      }
      if (ev.keyCode === 40) {
        // down
        if (this.selectedIndex === null) {
          this.selectedIndex = 0;
        } else {
          this.selectedIndex++;
        }
        if (this.selectedIndex >= this.optionsPossiblyFiltered.length) {
          this.selectedIndex = 0;
        }
        this.selectedFromDropdown = this.optionsPossiblyFiltered[this.selectedIndex];
        this.bringInViewport(this.selectedFromDropdown);
      }
      if (ev.keyCode === 13) {
        // enter
        if (this.optionsPossiblyFiltered.length === 1) {
          this.setResultOption(this.optionsPossiblyFiltered[0]);
        } else {
          // if something is selected with the keyboard, use tht
          if (this.selectedFromDropdown) {
            this.setResultOption(this.selectedFromDropdown);
          }
        }
      }
      if (ev.code === 'Escape') {
        __WEBPACK_IMPORTED_MODULE_3__event_bus_js__["a" /* EventBus */].$emit('overlayToggle', false);
        this.$refs.checkbox.checked = false;
      }
    },
    listenForInputChanges: function listenForInputChanges() {
      __WEBPACK_IMPORTED_MODULE_3__event_bus_js__["a" /* EventBus */].$on('pathchanged-' + this.randomId, this.pathValueUpdated);
    },
    fieldNeedsFocus: function fieldNeedsFocus() {
      if (this.$refs.checkbox) {
        this.$refs.checkbox.checked = true;
      }
      this.$refs.label.focus();
    },
    pathValueUpdated: function pathValueUpdated(data) {
      this.$emit('input', data);
      this.checkIfConfigNeedsSaving();
    },
    openBrowseDialog: function openBrowseDialog() {
      if (this.fileMask) {
        __WEBPACK_IMPORTED_MODULE_2__delphi_server__["a" /* default */].callback('FileDialogDI', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({ id: this.randomId, mask: this.fileMask }));
      } else {
        __WEBPACK_IMPORTED_MODULE_2__delphi_server__["a" /* default */].callback('FolderBrowserDialogDI', this.randomId);
      }
    },
    dropClick: function dropClick() {},
    setNewValue: function setNewValue(event) {
      // this would be THE place to do numeric validation
      // data tata, IN SFARSIT
      // console.log('New value', event.srcElement.value, 'old', this.value)
      // event.srcElement.value = this.value
      // return false
      // console.log('Changing value', this.triggersConfigSave)
      if (this.enforceNumericRules(event.srcElement.value)) {
        return false;
      }
      if (this.isCheckbox) {
        var isChecked = this.value;
        // first time it comes as string not as boolean
        if (isChecked === 'false') {
          isChecked = false;
        }
        if (isChecked === 'true') {
          isChecked = true;
        }
        this.$emit('input', !isChecked);
        this.checkIfConfigNeedsSaving();
        return true;
      }
      this.$emit('input', event.srcElement.value);
      this.checkIfConfigNeedsSaving();
    },
    dropEvent: function dropEvent(event) {
      var _this = this;

      // make this first so list is rendered properly
      this.searchText = '';
      this.selectedIndex = null;
      this.selectedFromDropdown = '';
      if (this.hasSearch) {
        this.$refs.search.focus();
      }
      // scroll element into view
      // make it on next tick so the search text has time to clear
      // and the proper item list rendered
      this.$nextTick(function () {
        _this.bringInViewport(_this.value);
        // const activeItem = this.$el.querySelector('span[data-value="' + (this.value.value || this.value) + '"]')
        // console.log('Scrolling into view', activeItem, this.value.value || this.value)
        // activeItem && activeItem.scrollIntoView()
      });
      __WEBPACK_IMPORTED_MODULE_3__event_bus_js__["a" /* EventBus */].$emit('overlayToggle', event.srcElement.checked);
    },
    bringInViewport: function bringInViewport(value) {
      var activeItem = this.$el.querySelector('span[data-value="' + (value.value || value) + '"]');
      // console.log('Scrolling into view', activeItem, this.value.value || this.value)
      activeItem && activeItem.scrollIntoView();
    },
    setResultOption: function setResultOption(value) {
      __WEBPACK_IMPORTED_MODULE_3__event_bus_js__["a" /* EventBus */].$emit('overlayCloseForPopup');
      /* assign either label or value directly */
      if (this.translatedLabel) {
        this.$emit('input', value.value);
      } else {
        this.$emit('input', value);
      }
      this.checkIfConfigNeedsSaving();
      this.$refs.checkbox.checked = false;
    },
    enforceNumericRules: function enforceNumericRules(value) {
      if (this.isInteger) {
        // console.log('Enforcing numeric rules if neces', value)
        this.$emit('input', parseFloat(value));
        return true;
        // this.value = parseFloat(this.value)
      }
    },
    toggleAccesibilityDropdown: function toggleAccesibilityDropdown(key) {
      if (!this.isDropDown) {
        return true;
      }
      // console.log('Key', key.code)
      if (key.code === 'Tab') {
        this.$refs.checkbox.checked = !this.$refs.checkbox.checked;
      }
      if (key.code === 'Escape') {
        __WEBPACK_IMPORTED_MODULE_3__event_bus_js__["a" /* EventBus */].$emit('overlayToggle', false);
        this.$refs.checkbox.checked = false;
      }
    },
    doPM: function doPM(modifier) {
      var newValue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(this.pmValue) ? parseInt(this.value) + modifier * this.pmValue : (parseFloat(this.value) + modifier * this.pmValue).toFixed(this.decimals);
      if (this.pmRound) {
        newValue = Math.round(newValue);
      }
      var cancelNewValue = false;
      if (typeof this.min !== 'undefined' && newValue < this.min) {
        cancelNewValue = true;
      }
      if (typeof this.max !== 'undefined' && newValue > this.max) {
        cancelNewValue = true;
      }
      if (!cancelNewValue) {
        // transform back to numeric if needed
        if (this.inputType === 'number') {
          newValue = parseFloat(newValue);
        }
        this.$emit('input', newValue);
        this.checkIfConfigNeedsSaving();
      }
    },
    receivedFocus: function receivedFocus(el, value) {
      var _this2 = this;

      if (value && this.selectAllOnEnter && !this.isFocused) {
        el.target.select();
      }

      if (this.keyboard) {
        if (value) {
          this.isFocused = true;
        } else {
          // when turning off, give time for the osk button click event to happen
          // console.log('Trying to turn off')
          setTimeout(function () {
            if (_this2.justClickedButton === false) {
              _this2.isFocused = false;
              _this2.firstKeyboardClick = false;
            } else {
              el.target.focus();
            }
            console.log('Setting firstKeyboardClick to false');
            _this2.justClickedButton = false;
          }, 150);
        }
      }
    },
    receiveKeyboardInput: function receiveKeyboardInput(value) {
      console.log('Got keyboard input', this.value, value, this.firstKeyboardClick);
      if (value === -1) {
        // return true
        var existingValue = '' + this.value;
        this.$emit('input', existingValue.slice(0, -1));
        this.justClickedButton = true;
        return true;
      } else if (value === -2) {
        // clicked ok, close
      } else {
        if (this.firstKeyboardClick === false) {
          this.$emit('input', value);
        } else {
          var newValue = parseInt('' + this.value + value);
          if (isNaN(newValue)) {
            newValue = value;
          }
          console.log('Append new value');
          this.$emit('input', newValue);
        }
        this.justClickedButton = true;
        this.firstKeyboardClick = true;
      }
    }
  },
  computed: {
    classObject: function classObject() {
      return {
        singleCheckbox: this.singleCheckbox,
        dropdown: this.isDropDown,
        alignright: this.alignright,
        checkbox: this.inputType === 'checkbox',
        readonly: this.readonly
      };
    },
    isRegularInput: function isRegularInput() {
      return ['text', 'password'].indexOf(this.inputType) > -1;
    },
    optionsPossiblyFiltered: function optionsPossiblyFiltered() {
      var _this3 = this;

      if (!this.hasSearch) {
        return this.options;
      }
      return this.options.filter(function (item) {
        var mainText = item.label || item.value || item;
        return mainText.toLowerCase().indexOf(_this3.searchText.toLowerCase()) > -1;
      });
    },
    visibleValue: function visibleValue() {
      var _this4 = this;

      if (this.webUnitsNumber) {
        return Math.round(this.value / 2);
      }
      if (this.value && this.value.label && typeof this.value.label === 'string') {
        return this.value.label;
      }
      // handle case when translation is needed
      if (this.translatedLabel) {
        var snipText = this.value;
        this.options.forEach(function (item) {
          if (item.value === _this4.value) {
            snipText = item.label;
          }
        });
        return snipText;
      }

      return this.value;
    },
    isDropDown: function isDropDown() {
      return this.type === 'dropdown';
    },
    isInteger: function isInteger() {
      return this.type === 'number';
    },
    isCheckbox: function isCheckbox() {
      return this.inputType === 'checkbox';
    },
    isReadOnly: function isReadOnly() {
      return (this.isDropDown || this.readonly) && !this.forceAllowText;
    },
    hasOverflow: function hasOverflow() {
      if (!this.options || !this.maxItems) {
        return false;
      }
      return this.options.length > this.maxItems;
    },
    styleDropdown: function styleDropdown() {
      return {
        height: 3.23 * this.maxItems + 'rem',
        maxHeight: 3.23 * this.maxItems + 'rem',
        overflowY: this.hasOverflow ? 'scroll' : 'visible'
      };
    }
  }
});

/***/ }),

/***/ "mAnb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_basic_DropOverlay__ = __webpack_require__("8FVN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_interactjs__ = __webpack_require__("u/64");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_interactjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_interactjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_basic_Btn__ = __webpack_require__("RUB1");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'IzDialog',
  props: {
    title: String,
    scroll: Boolean,
    disableDrag: Boolean,
    disableEscape: Boolean,
    simboltitle: String,
    disableOverlay: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      draggableHandle: null
    };
  },
  mounted: function mounted() {
    if (!this.disableDrag) {
      this.draggableHandle = __WEBPACK_IMPORTED_MODULE_1_interactjs___default()(this.$el).draggable({
        inertia: true,
        allowFrom: 'header',
        restrict: {
          restriction: 'parent',
          endOnly: true,
          elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
        },
        onmove: this.dragMoveListener
      });
    }
  },
  created: function created() {
    document.addEventListener('keyup', this.handleEscape);
  },
  destroyed: function destroyed() {
    document.removeEventListener('keyup', this.handleEscape);
  },

  methods: {
    handleEscape: function handleEscape() {
      if (event.keyCode === 27 && !this.disableEscape) {
        this.closeDialog();
      }
      if (event.keyCode === 13) {
        this.$emit('enterkey');
      }
    },
    dragMoveListener: function dragMoveListener(event) {
      var target = event.target;
      // keep the dragged position in the data-x/data-y attributes
      var x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;
      var y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;

      // translate the element
      // account for 50% initial translate
      target.style.webkitTransform = target.style.transform = 'translate(' + (x - target.clientWidth / 2) + 'px, ' + (y - target.clientHeight / 2) + 'px)';

      // update the posiion attributes
      target.setAttribute('data-x', x);
      target.setAttribute('data-y', y);
    },
    closeDialog: function closeDialog() {
      // keep this for compatibility
      this.$store.commit('closeDialogs');
    }
  },
  components: {
    Btn: __WEBPACK_IMPORTED_MODULE_2__components_basic_Btn__["a" /* default */],
    DropOverlay: __WEBPACK_IMPORTED_MODULE_0__components_basic_DropOverlay__["a" /* default */]
  },
  beforeDestroy: function beforeDestroy() {
    if (this.draggableHandle) {
      this.draggableHandle.unset();
    }
  }
});

/***/ }),

/***/ "nCf0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dialog_vue__ = __webpack_require__("mAnb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a9f269a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dialog_vue__ = __webpack_require__("KduR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("MbGm")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7a9f269a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a9f269a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dialog_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a9f269a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dialog_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "omHR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProgressBar_vue__ = __webpack_require__("i8tC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53e98dbe_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProgressBar_vue__ = __webpack_require__("yZyw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("kLER")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProgressBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53e98dbe_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProgressBar_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53e98dbe_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProgressBar_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sA9B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus_js__ = __webpack_require__("Usg1");
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    forced: Boolean
  },
  data: function data() {
    return {
      visible: false
    };
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* EventBus */].$on('overlayToggle', this.overlayToggle);
    __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* EventBus */].$on('overlayShow', this.overlayShow);
    __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* EventBus */].$on('overlayHide', this.overlayHide);
    __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* EventBus */].$on('overlayCloseForPopup', this.overlayCheckPopupClose);
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* EventBus */].$off('overlayToggle', this.overlayToggle);
    __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* EventBus */].$off('overlayShow', this.overlayShow);
    __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* EventBus */].$off('overlayHide', this.overlayHide);
    __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* EventBus */].$off('overlayCloseForPopup', this.overlayCheckPopupClose);
  },

  methods: {
    overlayToggle: function overlayToggle(value) {
      this.visible = value;
    },
    overlayShow: function overlayShow(value) {
      this.visible = true;
    },
    overlayHide: function overlayHide(value) {
      this.visible = false;
    },
    overlayCheckPopupClose: function overlayCheckPopupClose() {
      if (this.$parent.$el.classList.contains('modal')) {
        this.visible = false;
      } else {
        // if no modals are present then close
        var allDialogs = document.querySelectorAll('.modal');
        if (allDialogs.length === 0) {
          this.visible = false;
        }
      }
    },
    triggerMassClose: function triggerMassClose() {
      // it's forced when the invalid license dialog is visible
      if (this.forced) {
        return false;
      }

      var allDropdowns = document.querySelectorAll('.close-by-overlay');
      for (var i = 0; i < allDropdowns.length; ++i) {
        allDropdowns[i].checked = false;
      }

      // check that modals are still open
      if (this.$parent.$el.classList.contains('modal')) {
        this.visible = false;
      }

      __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* EventBus */].$emit('overlayCloseForPopup');

      // if no modals are present then close
      var allDialogs = document.querySelectorAll('.modal');
      if (allDialogs.length === 0) {
        this.visible = false;
      }
    }
  }
});

/***/ }),

/***/ "sk1G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("GPOn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72072a2f_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("MsIs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("Lm2a")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-72072a2f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72072a2f_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72072a2f_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xMpl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xxkG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_languages__ = __webpack_require__("fsWc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__event_bus_js__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_basic_DropOverlay__ = __webpack_require__("8FVN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_languages_dialogs_EnterLanguagePassword__ = __webpack_require__("PJJj");


//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LanguagesApp',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_languages__["a" /* default */]],
  components: {
    DropOverlay: __WEBPACK_IMPORTED_MODULE_4__components_basic_DropOverlay__["a" /* default */],
    DialogEnterLanguagePassword: __WEBPACK_IMPORTED_MODULE_5__modules_languages_dialogs_EnterLanguagePassword__["a" /* default */]
  },
  data: function data() {
    return {
      showPasswordPrompt: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var savedToken, passwordCheck;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              savedToken = _this.languagesGetToken();

              if (savedToken) {
                _context.next = 5;
                break;
              }

              _this.askForPassword();
              _context.next = 9;
              break;

            case 5:
              _context.next = 7;
              return _this.languagesVerifyPassword(savedToken);

            case 7:
              passwordCheck = _context.sent;

              if (!passwordCheck) {
                _this.askForPassword();
              }

            case 9:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    askForPassword: function askForPassword() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3__event_bus_js__["a" /* EventBus */].$emit('overlayShow');
      this.$nextTick(function () {
        _this2.showPasswordPrompt = true;
      });
    },
    successfulLogin: function successfulLogin() {
      __WEBPACK_IMPORTED_MODULE_3__event_bus_js__["a" /* EventBus */].$emit('overlayHide');
      this.showPasswordPrompt = false;
    }
  }
});

/***/ }),

/***/ "yKGw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SearchBox',
  props: {
    inputValue: {
      type: String,
      required: true
    },
    disabled: Boolean,
    placeholder: {
      type: String,
      default: 'Search job'
    }
  },
  data: function data() {
    return {
      searchString: ''
    };
  },
  mounted: function mounted() {
    this.searchString = this.inputValue;
  },

  methods: {
    reset: function reset() {
      this.searchString = '';
      this.$refs.searchElement.focus();
    }
  },
  watch: {
    searchString: function searchString(val) {
      /* might want to add a little _.debounce at some point */
      this.$emit('input', val);
      // this.$store.commit('prepress/SetJobSearchString', val)
    }
  }
});

/***/ }),

/***/ "yZyw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progressbar"},[_c('span',{class:{isError: _vm.isError},style:({width: _vm.currentProgress})})])}
var staticRenderFns = []


/***/ }),

/***/ "z6lR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AppLanguages__ = __webpack_require__("+FwJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_languages__ = __webpack_require__("1lFH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_languages__ = __webpack_require__("3Uzn");






/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_2__store_languages__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_3__router_languages__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__AppLanguages__["a" /* default */] }
});

/***/ })

},["z6lR"]);


// WEBPACK FOOTER //
// static/js/app.3ccdc9a62d06c7e4fb5b.js